<template>
	<h2 class="OtherInterestingForYou">Interesting programmes for you</h2>

	<div class="RecommendationsContainer">
		<div
			class="Recommendations"
			:data-identifier="dataIdentifier"
			data-recommendation-type="programmes"
			data-template="carousel"
			data-page="search"
			:data-filter-countries="countries"
			:data-filter-disciplines="disciplinesFilter"
			:data-filter-level="searchStore.portalType"
		></div>
	</div>
</template>

<script setup lang="ts">

import { useSearchStore } from '@app/stores/useSearchStore';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { computed, onMounted } from 'vue';
import { useEventSender } from '@app/composables/useEventSender';

const searchStore = useSearchStore();
const dataIdentifier = 'omni-search-recommendations';
const eventSender = useEventSender();

const lowResultsSuggestions = computed(()=> searchStore.pageData?.lowResultsSuggestions ?? []);
const disciplinesFilter = computed(() => lowResultsSuggestions.value.find(suggestion => suggestion.type === FilterType.DISCIPLINES)?.id);
const countries = computed(() => lowResultsSuggestions.value.find(suggestion => suggestion.type === FilterType.COUNTRY)?.id);



onMounted(()=>{
	eventSender.subscribeToRecommendationsEvents(dataIdentifier);
	eventSender.sendRecommendationsInitializationEvent(dataIdentifier);
	eventSender.updateRecommendations(dataIdentifier, countries.value, disciplinesFilter.value);
})
</script>

<style scoped lang="scss">
.RecommendationsContainer {
    @include PaddingAreas(1, 0, 0, 0);

	:deep(.StudyCardGrid) {
		background-color: transparent;
	}

	:deep(a) {
		color: $Blue-700;
	}
}

.OtherInterestingForYou {
	text-align: center;
	color: $Grey-900;

	@include Breakpoint(ExtraLarge) {
		@include MarginAreas(3, 0, 0, 0);
		@include TextStyle(HeadingLarge);
	}

	@include Breakpoint(Small, Medium, Large) {
		@include MarginAreas(2, 0, 0, 0);
		@include TextStyle(HeadingMedium);
	}
}
</style>